var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCopySolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 17.5a.5.5 0 0 1-.5.5H14v1.5a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5V18h-1.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H12v-1.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5V16h1.5a.5.5 0 0 1 .5.5zm2-6.5a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V12a1 1 0 0 1 1-1zm-6-4h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-1v-9a1 1 0 0 0-1-1h-9V8a1 1 0 0 1 1-1"
})));
export default SvgCopySolid;